////// Lib. //////
//////////////////

import Component from "gia/Component";
import { gsap } from "gsap";
import { loadLazyElements } from "../../../../app/modules/LazyLoad.js";

// Comp. class ///
//////////////////

export default class Contact extends Component {
  /////////// Constructor ////////////
  ////////////////////////////////////

  constructor(el, options) {
    super(el);

    //// DOM references ////
    ////////////////////////

    this.ref = {
      email: null,
      imgHover: null,
    };

    /////// Options ////////
    ////////////////////////

    this.options = {
      name: "Contact",
      duration: 0.5,
      ...options,
    };

    /////// State //////////
    ////////////////////////

    this._onEnter = null;
    this._onLeave = null;
    this._loaded = false;
  }

  ///////////// Mount ////////////////
  ////////////////////////////////////

  mount() {
    const { email, imgHover } = this.ref;
    if (!email || !imgHover) return;

    this._onEnter = () => this._toggle(true);
    this._onLeave = () => this._toggle(false);

    email.addEventListener("mouseenter", this._onEnter);
    email.addEventListener("mouseleave", this._onLeave);
    email.addEventListener("focus", this._onEnter);
    email.addEventListener("blur", this._onLeave);
  }

  //////////// Unmount ///////////////
  ////////////////////////////////////

  unmount() {
    const { email, imgHover } = this.ref;
    if (!email) return;

    email.removeEventListener("mouseenter", this._onEnter);
    email.removeEventListener("mouseleave", this._onLeave);
    email.removeEventListener("focus", this._onEnter);
    email.removeEventListener("blur", this._onLeave);

    this._onEnter = null;
    this._onLeave = null;

    if (imgHover) gsap.killTweensOf(imgHover);
  }

  /////////// Private ////////////////
  ////////////////////////////////////

  _toggle(isVisible) {
    const { imgHover } = this.ref;

    if (isVisible && !this._loaded) {
      this._loaded = true;
      loadLazyElements([imgHover]);
    }

    gsap.to(imgHover, {
      opacity: isVisible ? 1 : 0,
      duration: this.options.duration,
      ease: "power2.out",
      overwrite: "auto",
    });
  }
}
